// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file webhooks/v1/webhook.proto (package webhooks.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file webhooks/v1/webhook.proto.
 */
export const file_webhooks_v1_webhook: GenFile =
	/*@__PURE__*/
	fileDesc(
		"Chl3ZWJob29rcy92MS93ZWJob29rLnByb3RvEgt3ZWJob29rcy52MSKqAQoIUmVjZWl2ZXISCgoCaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJEg4KBm9yZ19pZBgDIAEoCRIMCgRuYW1lGAQgASgJEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIokBCghFbmRwb2ludBIKCgJpZBgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCRITCgtyZWNlaXZlcl9pZBgDIAEoCRILCgN1cmwYBCABKAkSEAoIZGlzYWJsZWQYBiABKAgSEgoKcmF0ZV9saW1pdBgHIAEoBRIUCgxmaWx0ZXJfdHlwZXMYCCADKAkiVwoJRXZlbnRUeXBlEgwKBG5hbWUYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkSJwoGc2NoZW1hGAMgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdCLJAQoHTWVzc2FnZRITCgtyZWNlaXZlcl9pZBgBIAEoCRIQCghldmVudF9pZBgCIAEoCRISCgpldmVudF90eXBlGAMgASgJEigKB3BheWxvYWQYBCABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0Ei0KCXRpbWVzdGFtcBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASCgoCaWQYBiABKAkSEAoIY2hhbm5lbHMYByADKAkSDAoEdGFncxgIIAMoCSLdAQoOTWVzc2FnZUF0dGVtcHQSEwoLcmVjZWl2ZXJfaWQYASABKAkSEwoLZW5kcG9pbnRfaWQYAiABKAkSEAoIcmVzcG9uc2UYAyABKAkSDgoGc3RhdHVzGAQgASgFEi0KCXRpbWVzdGFtcBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKAoHcGF5bG9hZBgGIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QSEgoKbWVzc2FnZV9pZBgHIAEoCRISCgpldmVudF90eXBlGAggASgJIkcKDkVuZHBvaW50U2VjcmV0EhMKC3JlY2VpdmVyX2lkGAEgASgJEhMKC2VuZHBvaW50X2lkGAIgASgJEgsKA2tleRgDIAEoCSJ1ChRFbmRwb2ludEN1c3RvbUhlYWRlchITCgtyZWNlaXZlcl9pZBgBIAEoCRITCgtlbmRwb2ludF9pZBgCIAEoCRIOCgZoZWFkZXIYAyABKAkSDQoFdmFsdWUYBCABKAkSFAoMaXNfc2Vuc2l0aXZlGAUgASgIInoKDUVuZHBvaW50U3RhdHMSEwoLcmVjZWl2ZXJfaWQYASABKAkSEwoLZW5kcG9pbnRfaWQYAiABKAkSDwoHc3VjY2VzcxgDIAEoAxIPCgdwZW5kaW5nGAQgASgDEg8KB3NlbmRpbmcYBSABKAMSDAoEZmFpbBgGIAEoA2IGcHJvdG8z",
		[file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * Receiver is the owner of endpoints that receive webhook payloads
 *
 * @generated from message webhooks.v1.Receiver
 */
export type Receiver = Message$1<"webhooks.v1.Receiver"> & {
	/**
	 * id is a reference-able id that is set by the consumer
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * the name of the webhooks receiver e.g. org name, username, etc.
	 *
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * timestamp the receiver was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp;

	/**
	 * timestamp the receiver was updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: Timestamp;
};

/**
 * Receiver is the owner of endpoints that receive webhook payloads
 *
 * @generated from message webhooks.v1.Receiver
 */
export type ReceiverJson = {
	/**
	 * id is a reference-able id that is set by the consumer
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * the name of the webhooks receiver e.g. org name, username, etc.
	 *
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * timestamp the receiver was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * timestamp the receiver was updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message webhooks.v1.Receiver.
 * Use `create(ReceiverSchema)` to create a new message.
 */
export const ReceiverSchema: GenMessage<Receiver, { jsonType: ReceiverJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 0);

/**
 * Endpoint represents a webhook destination
 *
 * @generated from message webhooks.v1.Endpoint
 */
export type Endpoint = Message$1<"webhooks.v1.Endpoint"> & {
	/**
	 * the endpoint id
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * description of the endpoint
	 *
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * the receiver ID to which the endpoint belongs
	 *
	 * @generated from field: string receiver_id = 3;
	 */
	receiverId: string;

	/**
	 * the URL of the endpoint
	 *
	 * @generated from field: string url = 4;
	 */
	url: string;

	/**
	 * true if the endpoint is disabled
	 *
	 * @generated from field: bool disabled = 6;
	 */
	disabled: boolean;

	/**
	 * rate limit for the endpoint
	 *
	 * @generated from field: int32 rate_limit = 7;
	 */
	rateLimit: number;

	/**
	 * the event types to which this endpoint is subcribed
	 *
	 * @generated from field: repeated string filter_types = 8;
	 */
	filterTypes: string[];
};

/**
 * Endpoint represents a webhook destination
 *
 * @generated from message webhooks.v1.Endpoint
 */
export type EndpointJson = {
	/**
	 * the endpoint id
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * description of the endpoint
	 *
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * the receiver ID to which the endpoint belongs
	 *
	 * @generated from field: string receiver_id = 3;
	 */
	receiverId?: string;

	/**
	 * the URL of the endpoint
	 *
	 * @generated from field: string url = 4;
	 */
	url?: string;

	/**
	 * true if the endpoint is disabled
	 *
	 * @generated from field: bool disabled = 6;
	 */
	disabled?: boolean;

	/**
	 * rate limit for the endpoint
	 *
	 * @generated from field: int32 rate_limit = 7;
	 */
	rateLimit?: number;

	/**
	 * the event types to which this endpoint is subcribed
	 *
	 * @generated from field: repeated string filter_types = 8;
	 */
	filterTypes?: string[];
};

/**
 * Describes the message webhooks.v1.Endpoint.
 * Use `create(EndpointSchema)` to create a new message.
 */
export const EndpointSchema: GenMessage<Endpoint, { jsonType: EndpointJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 1);

/**
 * EventType represents details of an event type from our catalog
 *
 * @generated from message webhooks.v1.EventType
 */
export type EventType = Message$1<"webhooks.v1.EventType"> & {
	/**
	 * the name of the event type
	 *
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * description of the event type
	 *
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * the schema of the event type
	 *
	 * @generated from field: google.protobuf.Struct schema = 3;
	 */
	schema?: JsonObject;
};

/**
 * EventType represents details of an event type from our catalog
 *
 * @generated from message webhooks.v1.EventType
 */
export type EventTypeJson = {
	/**
	 * the name of the event type
	 *
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * description of the event type
	 *
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * the schema of the event type
	 *
	 * @generated from field: google.protobuf.Struct schema = 3;
	 */
	schema?: StructJson;
};

/**
 * Describes the message webhooks.v1.EventType.
 * Use `create(EventTypeSchema)` to create a new message.
 */
export const EventTypeSchema: GenMessage<EventType, { jsonType: EventTypeJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 2);

/**
 * Message represents a webhook message
 *
 * @generated from message webhooks.v1.Message
 */
export type Message = Message$1<"webhooks.v1.Message"> & {
	/**
	 * the receiver to which the message was sent
	 *
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * id of the event
	 *
	 * @generated from field: string event_id = 2;
	 */
	eventId: string;

	/**
	 * the event type associated with the message
	 *
	 * @generated from field: string event_type = 3;
	 */
	eventType: string;

	/**
	 * the payload of the message
	 *
	 * @generated from field: google.protobuf.Struct payload = 4;
	 */
	payload?: JsonObject;

	/**
	 * the timestamp at which the payload was dispatched
	 *
	 * @generated from field: google.protobuf.Timestamp timestamp = 5;
	 */
	timestamp?: Timestamp;

	/**
	 * id of the message
	 *
	 * @generated from field: string id = 6;
	 */
	id: string;

	/**
	 * channels associated with the message
	 *
	 * @generated from field: repeated string channels = 7;
	 */
	channels: string[];

	/**
	 * tags associated with the message
	 *
	 * @generated from field: repeated string tags = 8;
	 */
	tags: string[];
};

/**
 * Message represents a webhook message
 *
 * @generated from message webhooks.v1.Message
 */
export type MessageJson = {
	/**
	 * the receiver to which the message was sent
	 *
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * id of the event
	 *
	 * @generated from field: string event_id = 2;
	 */
	eventId?: string;

	/**
	 * the event type associated with the message
	 *
	 * @generated from field: string event_type = 3;
	 */
	eventType?: string;

	/**
	 * the payload of the message
	 *
	 * @generated from field: google.protobuf.Struct payload = 4;
	 */
	payload?: StructJson;

	/**
	 * the timestamp at which the payload was dispatched
	 *
	 * @generated from field: google.protobuf.Timestamp timestamp = 5;
	 */
	timestamp?: TimestampJson;

	/**
	 * id of the message
	 *
	 * @generated from field: string id = 6;
	 */
	id?: string;

	/**
	 * channels associated with the message
	 *
	 * @generated from field: repeated string channels = 7;
	 */
	channels?: string[];

	/**
	 * tags associated with the message
	 *
	 * @generated from field: repeated string tags = 8;
	 */
	tags?: string[];
};

/**
 * Describes the message webhooks.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message, { jsonType: MessageJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 3);

/**
 * MessageAttempt represents an attempt at delivering a message to an endpoint
 *
 * @generated from message webhooks.v1.MessageAttempt
 */
export type MessageAttempt = Message$1<"webhooks.v1.MessageAttempt"> & {
	/**
	 * id of the receiver
	 *
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * id of the endpoint
	 *
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * response from the destination endpoint
	 *
	 * @generated from field: string response = 3;
	 */
	response: string;

	/**
	 * status of the message attempt
	 *
	 * @generated from field: int32 status = 4;
	 */
	status: number;

	/**
	 * timestamp at which the message was attempted
	 *
	 * @generated from field: google.protobuf.Timestamp timestamp = 5;
	 */
	timestamp?: Timestamp;

	/**
	 * the payload associated with the attempt
	 *
	 * @generated from field: google.protobuf.Struct payload = 6;
	 */
	payload?: JsonObject;

	/**
	 * the id of the message associated with the attempt
	 *
	 * @generated from field: string message_id = 7;
	 */
	messageId: string;

	/**
	 * the event type associated with the attempt
	 *
	 * @generated from field: string event_type = 8;
	 */
	eventType: string;
};

/**
 * MessageAttempt represents an attempt at delivering a message to an endpoint
 *
 * @generated from message webhooks.v1.MessageAttempt
 */
export type MessageAttemptJson = {
	/**
	 * id of the receiver
	 *
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * id of the endpoint
	 *
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * response from the destination endpoint
	 *
	 * @generated from field: string response = 3;
	 */
	response?: string;

	/**
	 * status of the message attempt
	 *
	 * @generated from field: int32 status = 4;
	 */
	status?: number;

	/**
	 * timestamp at which the message was attempted
	 *
	 * @generated from field: google.protobuf.Timestamp timestamp = 5;
	 */
	timestamp?: TimestampJson;

	/**
	 * the payload associated with the attempt
	 *
	 * @generated from field: google.protobuf.Struct payload = 6;
	 */
	payload?: StructJson;

	/**
	 * the id of the message associated with the attempt
	 *
	 * @generated from field: string message_id = 7;
	 */
	messageId?: string;

	/**
	 * the event type associated with the attempt
	 *
	 * @generated from field: string event_type = 8;
	 */
	eventType?: string;
};

/**
 * Describes the message webhooks.v1.MessageAttempt.
 * Use `create(MessageAttemptSchema)` to create a new message.
 */
export const MessageAttemptSchema: GenMessage<MessageAttempt, { jsonType: MessageAttemptJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 4);

/**
 * @generated from message webhooks.v1.EndpointSecret
 */
export type EndpointSecret = Message$1<"webhooks.v1.EndpointSecret"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key: string;
};

/**
 * @generated from message webhooks.v1.EndpointSecret
 */
export type EndpointSecretJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key?: string;
};

/**
 * Describes the message webhooks.v1.EndpointSecret.
 * Use `create(EndpointSecretSchema)` to create a new message.
 */
export const EndpointSecretSchema: GenMessage<EndpointSecret, { jsonType: EndpointSecretJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 5);

/**
 * @generated from message webhooks.v1.EndpointCustomHeader
 */
export type EndpointCustomHeader = Message$1<"webhooks.v1.EndpointCustomHeader"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: string header = 3;
	 */
	header: string;

	/**
	 * @generated from field: string value = 4;
	 */
	value: string;

	/**
	 * @generated from field: bool is_sensitive = 5;
	 */
	isSensitive: boolean;
};

/**
 * @generated from message webhooks.v1.EndpointCustomHeader
 */
export type EndpointCustomHeaderJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: string header = 3;
	 */
	header?: string;

	/**
	 * @generated from field: string value = 4;
	 */
	value?: string;

	/**
	 * @generated from field: bool is_sensitive = 5;
	 */
	isSensitive?: boolean;
};

/**
 * Describes the message webhooks.v1.EndpointCustomHeader.
 * Use `create(EndpointCustomHeaderSchema)` to create a new message.
 */
export const EndpointCustomHeaderSchema: GenMessage<EndpointCustomHeader, { jsonType: EndpointCustomHeaderJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 6);

/**
 * @generated from message webhooks.v1.EndpointStats
 */
export type EndpointStats = Message$1<"webhooks.v1.EndpointStats"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: int64 success = 3;
	 */
	success: bigint;

	/**
	 * @generated from field: int64 pending = 4;
	 */
	pending: bigint;

	/**
	 * @generated from field: int64 sending = 5;
	 */
	sending: bigint;

	/**
	 * @generated from field: int64 fail = 6;
	 */
	fail: bigint;
};

/**
 * @generated from message webhooks.v1.EndpointStats
 */
export type EndpointStatsJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: int64 success = 3;
	 */
	success?: string;

	/**
	 * @generated from field: int64 pending = 4;
	 */
	pending?: string;

	/**
	 * @generated from field: int64 sending = 5;
	 */
	sending?: string;

	/**
	 * @generated from field: int64 fail = 6;
	 */
	fail?: string;
};

/**
 * Describes the message webhooks.v1.EndpointStats.
 * Use `create(EndpointStatsSchema)` to create a new message.
 */
export const EndpointStatsSchema: GenMessage<EndpointStats, { jsonType: EndpointStatsJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_webhook, 7);
